// @flow
import React, { forwardRef } from 'react';
import { t } from 'Src/i18n';

// $FlowFixMe
export const AlternativeProposalsSeparatorDashed = forwardRef((props, ref) => {
  return (
    <div data-testid="AlternativeProposalsSeparatorDashed" ref={ref} className="flex mt-4 w-full">
      <div className="self-center border-t border-dashed flex-1" />
      <div className="font-bold mx-6 text-2xl text-blue">{t('booking.common.or')}</div>
      <div className="self-center border-t border-dashed flex-1" />
    </div>
  );
});
